export default class MagazineYearSelector {
  constructor(context) {
    this.context = context;

    this.control = null;

    this.initMagazineYearSelector();
  }

  initMagazineYearSelector() {
    this.control = this.context.querySelector('[data-magazine-year-selector="control"]');
    this.control.addEventListener('change', this.onChange);
  }

  onChange = (event) => {
    const searchParams = new URLSearchParams(window.location.search);

    if (event.target.value) {
      searchParams.set('year', event.target.value);
    } else {
      searchParams.delete('year');
    }

    const queryString = searchParams.toString() ? `?${searchParams.toString()}` : '';

    window.location = `${window.location.pathname}${queryString}#MagazineYearSelector`;
  };
}
